import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { UpdateTopupsSetupSchema } from "schema"
import { z } from "zod"
import { getSubscriptionQueryKey } from "../lib/subscriptionQuery"

type Props = z.infer<typeof UpdateTopupsSetupSchema>

export function useUpdateTopupsSetupMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: Props) => {
      const response = await axios.put("/billing/checkout/topups", data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getSubscriptionQueryKey() })
    },
  })
}
